import React, { useEffect, useState } from 'react';
import { AcquisitionFlow, getAcquisitionFlow, getAppData, getProgramData } from '../../../utils/acquisition-utils';
import { Col, Row } from '../../../importCL';
import { useAcquisitionContext } from '../../../providers/AcquisitionProvider/AcquisitionProvider';
interface IAuthorizedUserFormProps {
    addUserLabel?: string;
    auFirstName?: string;
    auMiddleInitial?: string;
    auLastName?: string;
    auSpouseLabel?: string;
    auDobLabel?: string;
}

const getAuthorizedUserInfo = async (): Promise<Record<string, any>> => {
    const appData = await getAppData();
    if (appData.AuthorizedUser) {
        return appData.AuthorizedUser;
    }
    if (appData.AdditionalInformation) {
        return appData.AdditionalInformation;
    }
    return {};
};

const getAuthorizedUserFee = async (): Promise<string> => {
    const programData = await getProgramData();
    
    if (getAcquisitionFlow() === AcquisitionFlow.PHA) {
        return programData?.card?.keyCardBenefits?.availableAncillaries?.find((anc) => anc?.title === 'AUTHORIZED_USER')?.fee as string ?? '0';
    }
    
    return programData.AuthorizedUserFeeInfo && programData.AuthorizedUserFeeInfo.Fee ?
        programData.AuthorizedUserFeeInfo.Fee.toString() : '0';
};

export const AuthorizedUserForm = (props: IAuthorizedUserFormProps): JSX.Element => {
    const [authorizedUserFee, setAuthorizedUserFee] = useState<any>();
    const [auInfo, setAuInfo] = useState<any>();
    const [isAuthorizedUserSelected, setIsAuthorizedUserSelected] = useState<boolean>();
    
    const { isAuthorizedUserInEditMode } = useAcquisitionContext();

    useEffect(() => {
        const setStates = async () => {
            const auFee = await getAuthorizedUserFee();
            const info = await getAuthorizedUserInfo();
            setAuInfo(info);
            setAuthorizedUserFee(auFee);
            setIsAuthorizedUserSelected(!!info.IsAuthorizedUserSelected);
        };
        setStates();
    }, [isAuthorizedUserInEditMode]);

    useEffect(() => {
        if (auInfo) {
            setIsAuthorizedUserSelected(auInfo.IsAuthorizedUserSelected);
        }
    }, [auInfo]);

    return (
        <React.Fragment>
            <div className='PersonalInformation__infoContainer'>
                <p>
                    <b>{props.addUserLabel}:</b>
                </p>
                <p>
                    {isAuthorizedUserSelected ? <React.Fragment>Yes <b>{`($${authorizedUserFee})`}</b></React.Fragment> : 'No'}
                </p>
            </div>
            {
                isAuthorizedUserSelected && (
                    <Row>
                        <Col sm={12} md={6}>
                            <div className='PersonalInformation__infoContainer'>
                                <p>
                                    <b>{props.auFirstName}</b>
                                </p>
                                <p>
                                    {auInfo.AuthorizedUserFirstName}
                                </p>
                            </div>
                            <div className='PersonalInformation__infoContainer'>
                                <p>
                                    <b>{props.auMiddleInitial}</b>
                                </p>
                                <p>
                                    {auInfo.AuthorizedUserMiddleInitial}
                                </p>
                            </div>
                            <div className='PersonalInformation__infoContainer'>
                                <p>
                                    <b>{props.auLastName}</b>
                                </p>
                                <p>
                                    {auInfo.AuthorizedUserLastName}
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} md={6}>
                            <div className='PersonalInformation__infoContainer'>
                                <p>
                                    <b>{props.auDobLabel}</b>
                                </p>
                                <p>
                                    {`${auInfo.AuthorizedUserDOBMonth}-${auInfo.AuthorizedUserDOBDay}-${auInfo.AuthorizedUserDOBYear}`}
                                </p>
                            </div>
                            <div className='PersonalInformation__infoContainer'>
                                <p>
                                    <b>{props.auSpouseLabel}</b>
                                </p>
                                <p>
                                    {auInfo.IsAuthorizedUserSpouse ? 'Yes' : 'No'}
                                </p>
                            </div>
                        </Col>
                    </Row>
                )
            }
        </React.Fragment>
    );
};